import type { ReactElement } from "react";
import type { ProblemTimelineParams } from "@playbookai/widget-schemas";
import type { WidgetBodyProps } from "../types.js";
import { ProblemTimelineEditor } from "./Editor.js";

/**
 * `def.ExpandedComponent` seam. The panel body is the editor itself — the
 * chronology, the milestone list and the exposure estimate are one workflow, so
 * both this seam and the legacy `ExpandedWidgetEditor` switch render the same
 * composition rather than two divergent layouts.
 */
export function ProblemTimelineExpandedEditor({
  data,
  onChange,
  readOnly,
}: WidgetBodyProps<ProblemTimelineParams>): ReactElement {
  return (
    <ProblemTimelineEditor
      data={data}
      onChange={onChange}
      readOnly={readOnly ?? false}
    />
  );
}
